import React from "react";
import { Button } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";

const ThemedButton = createThemedComponent(Button, {
  ButtonContent_justifyContent: "left",
  Button_fontSize_medium: 22.5
});

class LeftButton extends React.Component {
  render() {
    return <ThemedButton {...this.props} naked />;
  }
}

export default LeftButton;
